import React from 'react';
import { Breadcrumb, Typography } from 'antd';
import { Link } from 'react-router-dom';

const { Title } = Typography;

const BreadcrumbComponent = ({ title, items = [] }) => {
  return (
    <div style={{ marginBottom: '12px', marginLeft: '9px', fontFamily: 'Poppins' }}>
      {/* Optional Title */}
      {title && (
        <Title
          level={4}
          style={{
            marginBottom: '0px', // 🔽 decreased space below title
            marginTop: '0px',     // 🔽 removed extra top space
            fontFamily: 'Poppins'
          }}
        >
          {title}
        </Title>
      )}

      {/* Breadcrumb with styled separator */}
      <Breadcrumb
        separator={
          <span style={{ fontSize: '12px', color: '#333', margin: '0 6px' }}>
            ›
          </span>
        }
      >


        {items.map((item, index) => (
          <Breadcrumb.Item
            key={index}
            style={{ fontFamily: 'Poppins', fontSize: '11px' }}
          >
            {item.to ? (
              <Link style={{ fontFamily: 'Poppins', fontSize: '11px' }} to={item.to}>
                {item.title}
              </Link>
            ) : (
              <span style={{ fontFamily: 'Poppins', fontSize: '11px' }}>{item.title}</span>

            )}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default BreadcrumbComponent;
